import * as actions from './solicitacao.action';
import inicialState from './solicitacao.state';

const solicitacoesReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.SOLICITACOES_LISTA:
      return {
        ...state,
        listaSolicitacoes: action.payload.listaSolicitacoes
      };
    case actions.TOTAL_SOLICITACOES_SOLICITADAS:
      return {
        ...state,
        totalSolicitado: action.payload.totalSolicitado
      };
    default:
      return state;
  }
};

export default solicitacoesReducer;



// WEBPACK FOOTER //
// ./src/pages/solicitacao/solicitacao.reducer.js